import React, { Component } from 'react';
import Fade from 'react-reveal/Fade';
import { Link } from 'react-router-dom';
import {
  Grid,
  Row,
  Col,
  FormControl,
  InputGroup,
  FormGroup,
  Button,
  HelpBlock,
  ControlLabel,
} from 'react-bootstrap';
import CaseStudy from '../common/CaseStudy';
import ailsaFeatured from '../../img/featured-imgs/ailsa-bay-featured.jpg';
import downstreamFeatured from '../../img/featured-imgs/icb-featured.jpg';
import blackwaterFeatured from '../../img/featured-imgs/blackwater-featured.jpg';
import edenMillFeatured from '../../img/featured-imgs/eden-mill-featured.jpg';
import goIcon from '../../img/featured-imgs/go-icon.svg';
import './CaseStudies.css';

class CaseStudies extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      validEmail: true,
      icb: {
        heading: 'Ireland Craft Beers - Downstream Storybook',
        text: 'From barley to bottle – the world’s first blockchain beer',
      },
      ailsaBay: {
        heading: 'Ailsa Bay Storybook',
        text: 'Distilled with craft, refined by code.',
      },
      blackWater: {
        heading: 'Irish Blackwater Gin',
        text: 'Coming soon: Distillery Management Platform',
      },
      edenMill: {
        heading: 'Eden Mill',
        text: 'Coming soon: Distillery Management Platform',
      },
    };
  }

  onClickSubmit(e) {
    e.preventDefault();
    this.validateForm();
  }

  isEmailValid(email) {
    const regex =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return regex.test(String(email).toLowerCase());
  }

  validateForm() {
    const { email } = this.state;
    this.setState({
      validEmail: this.isEmailValid(email),
    });
  }

  render() {
    return (
      <div className="case-studies">
        <Grid fluid className="grid-fluid">
          <Fade delay={200}>
            <Row>
              <Col md={12}>
                <div className="header">
                  <h1 className="page-title">Case studies</h1>
                  <h3 className="page-description">
                    {' '}
                    Find out more about our recent partnerships
                  </h3>
                </div>
              </Col>
            </Row>
          </Fade>
          <Row>
            <Col md={6} xs={12}>
              <Fade delay={400}>
                <Row>
                  <Link to="/case_studies/irelandcraftbeers">
                    <Col md={12} xs={12} className="overlay">
                      <CaseStudy
                        image={downstreamFeatured}
                        overlay={this.state.icb}
                      />
                    </Col>
                  </Link>
                </Row>
              </Fade>
            </Col>
            <Col md={6} xs={12}>
              <Fade delay={400}>
                <Row>
                  <Link to="/case_studies/ailsabay">
                    <Col md={12} xs={12} className="image-three">
                      <CaseStudy
                        image={ailsaFeatured}
                        overlay={this.state.ailsaBay}
                      />
                    </Col>
                  </Link>
                </Row>
              </Fade>
            </Col>
          </Row>
          <Fade>
            <Row className="featured-double">
              <Col md={6} xs={12}>
                <CaseStudy
                  image={blackwaterFeatured}
                  overlay={this.state.blackWater}
                />
              </Col>
              <Col md={6} xs={12}>
                <CaseStudy
                  image={edenMillFeatured}
                  overlay={this.state.edenMill}
                />
              </Col>
            </Row>
          </Fade>
          <Fade>
            <Row className="email-row">
              <h1>Like what you see?</h1>
              <h3>
                Want to talk through a project? Find out more about us? We'd
                love to hear from you.
              </h3>
              <Col md={8} mdOffset={2} s={10} xs={12}>
                <div className="email-contact">
                  <form
                    className="form"
                    action="https://distilledid.us19.list-manage.com/subscribe/post?u=6e0c08acecd6f451122ecc6f7&amp;id=66bf4fdc88"
                    method="post"
                  >
                    <FormGroup>
                      <ControlLabel>Register interest</ControlLabel>

                      <InputGroup>
                        <FormControl
                          className="email-input"
                          type="text"
                          id="mce-EMAIL"
                          name="EMAIL"
                          placeholder="email@company.com"
                          value={this.state.email}
                          onChange={(e) => {
                            this.setState({
                              email: e.target.value,
                              validEmail: this.isEmailValid(e.target.value),
                            });
                          }}
                        />
                        <InputGroup.Button>
                          <Button
                            className="email-submit"
                            type="submit"
                            value="Subscribe"
                            name="subscribe"
                            disabled={!this.isEmailValid(this.state.email)}
                          >
                            <img src={goIcon} alt="submit" />
                          </Button>
                        </InputGroup.Button>
                        <FormControl.Feedback />
                      </InputGroup>
                      {!this.state.validEmail && (
                        <HelpBlock>Valid email is required</HelpBlock>
                      )}
                    </FormGroup>
                  </form>
                </div>
              </Col>
            </Row>
          </Fade>
        </Grid>
      </div>
    );
  }
}

export default CaseStudies;



// WEBPACK FOOTER //
// ./src/components/views/CaseStudies.js